import jackpotChestImage from '@media/images/JackpotChest.png'
import RippleButton from '../../../../../components/ui/RippleButton'

// Pure render. `jackpot` is the mapper's view model (ACTIVE rows have no
// `endedDate`/`reward` — they render blank/zero, matching defenderV2's card
// exactly, which shows the same two rows unconditionally for both variants.
const JackpotCard = ({ jackpot, currencyCode, onView }) => (
  <div className="standard-normal-jackpot-card-outer-container">
    <div className="standard-normal-jackpot-card-inner-container">
      <div className="standard-normal-jackpot-card-chest-container">
        <div className="standard-normal-jackpot-card-chest-icon">
          <img src={jackpotChestImage} alt="Jackpot Chest" width="50" height="50" />
        </div>
        <div className="standard-normal-jackpot-card-maturity-meter">
          {jackpot?.maturityValue}/{jackpot?.maturityValue}
        </div>
      </div>

      <div className="standard-normal-jackpot-card-info-container">
        <div className="standard-normal-jackpot-card-title-block">
          <div className="standard-normal-jackpot-card-name">{jackpot?.name ?? 'Jackpot'}</div>
          <div className="standard-normal-jackpot-card-ended-row">
            <span>Ended</span>
            <span>:</span>
            <span>{jackpot?.endedDate}</span>
          </div>
        </div>

        <div className="standard-normal-jackpot-card-divider" />

        <div className="standard-normal-jackpot-card-action-row">
          <div className="standard-normal-jackpot-card-reward-block">
            <span>My Reward</span>
            <span>:</span>
            <span className="standard-normal-jackpot-card-reward-value">
              <span>{currencyCode}</span>
              <span>{jackpot?.reward ?? 0}</span>
            </span>
          </div>
          <div className="standard-normal-jackpot-card-action-button-container">
            <RippleButton className="standard-normal-jackpot-card-action-button" onClick={onView}>
              Jackpot Result
            </RippleButton>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default JackpotCard
